import React, { useEffect, useRef, useState } from 'react'
import BannerOne from '../Components/Banner/BannerOne'
import CategoryOne from '../Components/Category/CategoryOne'
import DestinationOne from '../Components/Destination/DestinationOne'
import TourOne from '../Components/Tour/TourOne'
import GalleryOne from '../Components/Gallery/GalleryOne'
import CounterOne from '../Components/Counter/CounterOne'
import TestimonialOne from '../Components/Testimonials/TestimonialOne'
import ScrollToTop from '../Components/ScrollToTop'
import AboutOne from '../Components/About/AboutOne'
import BlogFour from '../Components/Blog/BlogFour'

function HomeOne({ data }) {

  const [sliders, setSliders] = useState([]);
  const [reviews, setReview] = useState([]);
  const [category, setCategory] = useState([]);
  const [temples, setTemples] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [blogs, setBlog] = useState([]);

  const handleCategoryClick = (category) => {
  const element = document.getElementById(`category-${category.id}`);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

  const tourRef = useRef(null);   // 👈 scroll target

  useEffect(() => {
    if (data) {
      setSliders(data.sliders);
      setCategory(data.category);
      setTemples(data.temples);
      setGallery(data.gallery);
      setReview(data.reviews);
      setBlog(data.blogs);
    }
  }, [data]);



  return (
    <div>
      <BannerOne sliders={sliders} />

      <CategoryOne 
        categories={category}
        onCategoryClick={handleCategoryClick}   // 👈 pass function
      />

      <DestinationOne destinations={temples} />
      <AboutOne />

      <div ref={tourRef}>
        <TourOne 
          categories={category}
        />
      </div>
      
      <GalleryOne gallery={gallery} />
      <CounterOne />
      <TestimonialOne testimonials={reviews} />
      <BlogFour blogs={blogs} />
      <ScrollToTop />
    </div>
  )
}

export default HomeOne
